import { Stack, Tooltip } from '@mui/material'

import { memo } from 'react'
import Text from './Text'

const DisplayValue = ({ title, desc, titleHelpText, fontSize = 50 }) => {
  const titleLabel = (
    <Text
      variant='body1'
      label={title}
      sx={{ fontSize, fontWeight: 800, lineHeight: 1 }}
    />
  )
  return (
    <Stack
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 2,
        p: 2
      }}
      spacing={1}
    >
      {titleHelpText ? (
        <Tooltip title={titleHelpText}>
          <span>{titleLabel}</span>
        </Tooltip>
      ) : (
        titleLabel
      )}
      {desc && <Text variant='body1' label={desc} fontWeight={500} />}
    </Stack>
  )
}

export default memo(DisplayValue)
